module.exports = "/assets/data/0d924338803b43d21a0f7e11397d3d8e-GU28.data.json";